/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OsisRuleState
 */
export interface OsisRuleState {
    /**
     * 
     * @type {string}
     * @memberof OsisRuleState
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OsisRuleState
     */
    disabled?: boolean;
}

export function OsisRuleStateFromJSON(json: any): OsisRuleState {
    return OsisRuleStateFromJSONTyped(json, false);
}

export function OsisRuleStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): OsisRuleState {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
    };
}

export function OsisRuleStateToJSON(value?: OsisRuleState | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'disabled': value.disabled,
    };
}


